

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component,ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AlertComponent } from './_directives/index';
import { AlertService, AuthenticationService, UserService } from './service/index';
import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

import { AuthguardService } from './service/authguard.service';
import { HomeComponent } from './home/home.component';
import { RegisterComponent } from './register/index';

import { MyDatePickerModule } from 'mydatepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ForgotUserIdComponent } from './forgot-user-id/forgot-user-id.component';
import { ForgotUseridSuccessComponent } from './forgot-userid-success/forgot-userid-success.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordSuccessComponent } from './forgot-password-success/forgot-password-success.component';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { ComponentsComponent } from './layout/components/components.component';
import { HeaderComponent } from './layout/Components/header/header.component';
import { SidebarComponent } from './layout/Components/sidebar/sidebar.component';
import { DemoComponent } from './demo/demo.component';
import { DataFilterPipe } from '../app/td-statment-of-account/data-filter.pipe';
import { DataFilterPipeForCA } from './customer-activity/data-filter-for-ca.pipe';

import { DataTableModule } from "angular2-datatable";
// import { DataTablesModule } from "angular-datatables";
import { AddPayeeComponent } from './add-payee/add-payee.component';
import { AdhaarUpdateComponent } from "./adhaar-update/adhaar-update.component";
import { AtmCardRequestComponent } from "./atm-card-request/atm-card-request.component";
import { BranchToBranchTransferComponent } from "./branch-to-branch-transfer/branch-to-branch-transfer.component";
import { CallBackEndService } from './call-back-end.service';
import { ChequeBookRequestComponent } from "./cheque-book-request/cheque-book-request.component";
import { CustomerActivityComponent } from "./customer-activity/customer-activity.component";
import { ImpsTransferComponent } from "./imps-transfer/imps-transfer.component";
import { ModifyOrDeletePayeeComponent } from './modify-or-delete-payee/modify-or-delete-payee.component';
import { TdAccountComponent } from './td-account/td-account.component';
import { LoanAccountComponent } from './loan-account/loan-account.component';
import { MiniStatmentOfAccountComponent } from './mini-statment-of-account/mini-statment-of-account.component';
import { LoanStatmentOfAccountComponent } from './loan-statment-of-account/loan-statment-of-account.component';
import { OwnAccountTransferComponent } from "./own-account-transfer/own-account-transfer.component";
import { QuickTransferComponent } from "./quick-transfer/quick-transfer.component";
import { RtgsNeftTransferComponent } from "./rtgs-neft-transfer/rtgs-neft-transfer.component";
import { TdStatmentOfAccountComponent } from './td-statment-of-account/td-statment-of-account.component';
import { StatmentOfAccountComponent } from './statment-of-account/statment-of-account.component';
import { NeftComponent } from './neft/neft.component';
import { ScoComponent } from './sco/sco.component';
import { timerComponent } from "./cheque-book-request/timerComponent";
import { ChequeStatusRequestComponent } from "./cheque-status-request/cheque-status-request.component";
import { ChequeStopRequestComponent } from "./cheque-stop-request/cheque-stop-request.component";
import { NewUserByBankComponent } from './new-user-by-bank/new-user-by-bank.component';
import { SocialSecurityComponent } from "./social-security/social-security.component";
import { AtmcardblockComponent } from './atmcardblock/atmcardblock.component';
import { TimersComponent } from "./layout/components/header/timers/timers.component";
import { StandingInstructionComponent } from "./standing-instruction/standing-instruction.component";
import { UpdateEmailComponent } from "./update-email/update-email.component";
import { UpdateMobileComponent } from "./update-mobile/update-mobile.component";
import { FixedDepositeComponent } from './fixed-deposite/fixed-deposite.component';

import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { TdMaturityInstructionComponent } from './td-maturity-instruction/td-maturity-instruction.component';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {ShowSuccessComponent} from "./show-success/show-success.component";
import {ErrorComponent} from "./error/error.component";


import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { SecurityComponent } from './security/security.component';
import { TitleComponent } from './title/title.component';

import {FooterComponent} from "./layout/components/footer/footer.component";
import { NgChatModule } from 'ng-chat';
import { ChatComponent } from './chat/chat.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { FixedDepositComponent } from './fixed-deposit/fixed-deposit.component';
import { ToastrModule } from 'ngx-toastr';
import { LoanIntCertificateComponent } from './loan-int-certificate/loan-int-certificate.component';

import { TdIntCertificateComponent } from './td-int-certificate/td-int-certificate.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SessionTimerComponent } from './session-timer/session-timer.component';

import { ChangePasswordAfterExpireComponent } from './change-password-after-expire/change-password-after-expire.component';
import { LoanAccountDetailsComponent } from './loan-account-details/loan-account-details.component';
import { LoanDisburseDetailsComponent } from './loan-disburse-details/loan-disburse-details.component';
//import { MyAccountsComponent } from './my-accounts/my-accounts.component';
import { BlockCopyPasteDirective } from './_directives/blockCopyPasteDirective';
import { CardMenuComponent } from './card-menu/card-menu.component';
import { BotDetectCaptchaModule, CaptchaComponent } from 'angular-captcha';
import { PositivepayComponent } from './positivepay/positivepay.component';
import { PositivepaystatusComponent } from './positivepaystatus/positivepaystatus.component';
import { InwardChequeComponent } from './inward-cheque/inward-cheque.component';
import { JonitAccHolderComponent } from './jonit-acc-holder/jonit-acc-holder.component';
import { ImpsMenuComponent } from './imps-menu/imps-menu.component';
import { UpiMenuComponent } from './upi-menu/upi-menu.component';
//import { JonitAccHolderComponent } from './app/jonit-acc-holder/jonit-acc-holder.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AlertComponent,
    DataFilterPipeForCA,
    HomeComponent,
    RegisterComponent,

    ForgotUserIdComponent,
    ForgotUseridSuccessComponent,
    ForgotPasswordComponent,
    ForgotPasswordSuccessComponent,
    LayoutComponent,
    DashboardComponent,
    ComponentsComponent,
    ErrorComponent,
    SidebarComponent,
    DemoComponent,
  DataFilterPipe,

	
    AddPayeeComponent,
    ModifyOrDeletePayeeComponent,
    TdAccountComponent,
    LoanAccountComponent,
    MiniStatmentOfAccountComponent,
    LoanStatmentOfAccountComponent,
    TdStatmentOfAccountComponent,
    StatmentOfAccountComponent,
    BranchToBranchTransferComponent,
    OwnAccountTransferComponent,
    QuickTransferComponent,
    RtgsNeftTransferComponent,
    NeftComponent,
    ImpsTransferComponent,
    AdhaarUpdateComponent,
    HeaderComponent,
    ScoComponent,
    NewUserByBankComponent,
    CustomerActivityComponent,
    SocialSecurityComponent,
    ChequeBookRequestComponent,
    ChequeStatusRequestComponent,
    ChequeStopRequestComponent,
    AtmcardblockComponent,
    AtmCardRequestComponent,
    TimersComponent,
    StandingInstructionComponent,
    UpdateMobileComponent,
    UpdateEmailComponent,
    FixedDepositeComponent,
    TdMaturityInstructionComponent,
    ShowSuccessComponent,
    TermsConditionsComponent,
    DisclaimerComponent,
    PrivacyComponent,
    SecurityComponent,
    TitleComponent,
    timerComponent,
      FooterComponent,
      ChatComponent,
      ChangePasswordComponent,
      FixedDepositComponent,
      LoanIntCertificateComponent,
      TdIntCertificateComponent,
      SessionTimerComponent,
     
      ChangePasswordAfterExpireComponent,
     
      LoanAccountDetailsComponent,
     
      LoanDisburseDetailsComponent,
     
     // MyAccountsComponent,
      BlockCopyPasteDirective,
     
     CardMenuComponent,
     PositivepayComponent,
     
     PositivepaystatusComponent,
    
     InwardChequeComponent,
     
     JonitAccHolderComponent,
     UpiMenuComponent ,
     //CaptchaComponent,
     //ActivityFilterPipe
     // BotDetectCaptchaModule ,
     ImpsMenuComponent,
     
 ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule ,
    routing,
    MyDatePickerModule,
    
    DataTableModule,
    NgChatModule,
    Ng4LoadingSpinnerModule,
    Ng4LoadingSpinnerModule.forRoot(),
    ToastrModule.forRoot({
       timeOut: 10000,
    positionClass: 'toast-top-center',
    preventDuplicates: false,
  // positionClass: 'inline'
	}),
	  NgIdleKeepaliveModule.forRoot(),
    BotDetectCaptchaModule,
   
//DataTablesModule,
  ],
  providers: [
        AuthguardService,
        AlertService,
        AuthenticationService,
        UserService,
        CallBackEndService,
        TitleComponent,
		timerComponent,
    SessionTimerComponent,
   
    // {provide: Window, useValue: window},
     {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/app.module.ts